(() => {
    const cookieFavorites = document.cookie.split('; ').find(row => row.startsWith('favorites'));

    if (cookieFavorites) {
        const favorites = cookieFavorites.split('=')[1];

        if (favorites) {
            window.favorites = favorites.split(',');
        }
    }

    const favoriteBtn = document.querySelector('[data-estate-favorite]');

    if (favoriteBtn) {
        var favorites = [];
        const estateId = favoriteBtn.dataset.estateId;

        const cookieFavorites = document.cookie.split('; ').find(row => row.startsWith('favorites'));

        const expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 12);

        if (cookieFavorites) {
            const values = cookieFavorites.split('=')[1];

            if (values) {
                favorites = values.split(',');
            }
        }

        if (favorites.includes(estateId)) {
            favoriteBtn.classList.add('is-active');
        }

        favoriteBtn.addEventListener('click', (event) => {

            if (!favorites.includes(estateId)) {
                favorites.push(estateId);

                document.cookie = "favorites=" + favorites.toString() + ";path=/;expires=" + expiryDate.toUTCString();

                event.currentTarget.classList.add('is-active');
            } else {
                const index = favorites.indexOf(estateId);

                if (index > -1) {
                    favorites.splice(index, 1);
                }

                if (favorites.length === 0) {
                    document.cookie = "favorites=;";
                } else {
                    document.cookie = "favorites=" + favorites.toString() + ";path=/;expires=" + expiryDate.toUTCString();
                }

                event.currentTarget.classList.remove('is-active');
            }
        });
    }
})();
